export const environment = {
  name: 'prod',
  befreeUrl: 'https://social.befree.ru',
  production: true,
  isMonitoringEnabled: true,
};
